<!-- Template for the action button that parent component can render -->
<ng-template #actionButton>
  <iris-button
    id="pendo-insurance-verification-failed"
    data-test="insurance-verification-faled-exit-button"
    [type]="IrisButtonTypes.PRIMARY"
    (click)="confirm()"
  >
    Continue
  </iris-button>
</ng-template>

<div class="insurance-verification-failed-wrapper">
  <img alt="Insurance Verification Failed" src="/assets/setup/insurance.svg">
  <h4 data-test="header-insurance-review">
    We need your help
  </h4>
  <p data-test="insurance-review-paragraph-text">
    Things aren't working like they should. A disruption to our verification vendor means we can't verify your insurance right now.
  </p>

  <p>
    But, we can move forward! For quick verification, you can contact your insurance carrier to verify that we are in-network with your plan.
    Or, we can do this once service is restored, after you create your account.
  </p>
  <p>When you're ready, let's continue.</p>
  <br>
  @if (!fromDirectBooking) {
    <iris-button-container>
      <ng-container *ngTemplateOutlet="actionButton"></ng-container>
    </iris-button-container>
  }
</div>
